import { useState, useMemo } from 'react';
import {
  Box,
  Chip,
  TextField,
  Autocomplete,
  useTheme,
  Paper,
} from '@mui/material';
import { i18n } from '../../translate/i18n';

export function StatusFilter({ onFiltered }) {
  const theme = useTheme();
  const [selecteds, setSelecteds] = useState([]);

  // 🎯 Mapeamento de cores por status
  const statusColorMap = useMemo(
    () => ({
      Aberto: theme.custom.colors.confirmButton,
      Fechado: theme.custom.colors.editButton,
      Cancelado: theme.custom.colors.cancelButton,
      Pendente: '#fd6500',
      Grupos: '#9c27b0',
    }),
    [theme],
  );

  const status = [
    {
      status: 'open',
      name: `${i18n.t('tickets.search.filterConectionsOptions.open')}`,
    },
    {
      status: 'closed',
      name: `${i18n.t('tickets.search.filterConectionsOptions.closed')}`,
    },
    {
      status: 'pending',
      name: `${i18n.t('tickets.search.filterConectionsOptions.pending')}`,
    },
    {
      status: 'canceled',
      name: 'Cancelado',
    },
    { status: 'group', name: 'Grupos' },
  ];

  const onChange = (event, value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  return (
    <Box style={{ padding: '2.5px 10px' }}>
      <Autocomplete
        multiple
        size='small'
        options={status}
        value={selecteds}
        onChange={onChange}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.status === value.status}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => {
            const { key, ...tagProps } = getTagProps({ index });
            return (
              <Chip
                key={key}
                variant='outlined'
                sx={{
                  backgroundColor: statusColorMap[option.name] || '#bfbfbf',
                  textShadow: '1px 1px 1px #000',
                  color: '#FFF',
                }}
                label={option.name}
                {...tagProps}
                size='small'
              />
            );
          })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant='outlined'
            placeholder='Filtro por Status'
            sx={theme.custom.selectField}
          />
        )}
        PaperComponent={({ children }) => (
          <Paper
            sx={{
              backgroundColor: theme.custom.colors.defaultBackground,
              '& .MuiAutocomplete-listbox': {
                color: theme.custom.colors.text,
              },
            }}
          >
            {children}
          </Paper>
        )}
      />
    </Box>
  );
}
